<script>
    import { fade, fly } from "svelte/transition";

    export let text;
    export let timeout = 2000;

    let presentToast = false;

    export function present() {
        presentToast = true;
        setTimeout(() => {
            presentToast = false;
        }, timeout);
    }

    export function timeoutValue() {
        return timeout;
    }
</script>

{#if presentToast}
    <div class="toast" in:fly={{ y: -500, duration: 400 }} out:fade>
        {text}
    </div>
{/if}

<style>
    .toast {
        @apply reset fixed top-10 w-full bg-black px-4 py-2 text-center text-sm text-white sm:top-12 md:w-[50%] md:min-w-[50%] md:rounded !important;
    }
</style>
